const PaymentPlatforms = {
  stripe: 'stripe',
  spreedly: 'spreedly',
  payfabric: 'payfabric',
};

export default PaymentPlatforms;
